<div class="landing-container">
  @if (isLoading) {
  <div class="loading-state">
    <p>Loading your media...</p>
  </div>
  }

  @if (printUrl || gifUrl) {
  <div class="actions-container">
    <button class="primary-btn save-btn" (click)="saveToGallery()" [disabled]="isClaimed || isClaiming">
      {{ isClaiming ? 'Saving...' : (isClaimed ? '✓ Saved in my gallery' : '💾 Save in my gallery') }}
    </button>
  </div>

  <div class="media-container">
    @if (gifUrl) {
    <div class="media-item" [style.visibility]="photoOrientations['gif'] ? 'visible' : 'hidden'">
      <button (click)="downloadMedia(gifUrl, 'gif')" class="download-img-btn" aria-label="Download GIF">
        <img src="Assets/currentSession/downloadGIF.png" alt="Download GIF" />
      </button>

      @if (photoOrientations['gif'] === 'strip') {
      <div class="keyring-frame-container clickable" (click)="openModal(gifUrl)">
        <img class="keyring-base" src="Assets/currentSession/keyring.png" alt="Keyring" />
        <img class="user-strip-overlay" [src]="gifUrl" alt="Session GIF" (load)="onImageLoad($event, 'gif')" />
      </div>
      } @else if (photoOrientations['gif'] === '4x6') {
      <div class="camera-frame-4x6-container clickable" (click)="openModal(gifUrl)">
        <img class="camera-base" src="Assets/currentSession/camera_4x6.png" alt="Camera" />
        <img class="user-photo-4x6-overlay" [src]="gifUrl" alt="Session GIF" (load)="onImageLoad($event, 'gif')" />
      </div>
      } @else if (photoOrientations['gif'] === '6x4') {
      <div class="camera-frame-container clickable" (click)="openModal(gifUrl)">
        <img class="camera-base" src="Assets/currentSession/camera.png" alt="Camera" />
        <img class="user-photo-overlay" [src]="gifUrl" alt="Session GIF" (load)="onImageLoad($event, 'gif')" />
      </div>
      } @else {
      <div class="img-wrapper clickable" (click)="openModal(gifUrl)">
        <img class="base-media" [src]="gifUrl" alt="Session GIF" (load)="onImageLoad($event, 'gif')" />
      </div>
      }

      <!-- Hidden image solely to trigger load event if orientation is not yet calculated -->
      @if (!photoOrientations['gif']) {
      <img [src]="gifUrl" style="display:none;" (load)="onImageLoad($event, 'gif')" />
      }
    </div>
    }

    @if (printUrl) {
    <div class="media-item" [style.visibility]="photoOrientations['print'] ? 'visible' : 'hidden'">
      <button (click)="downloadMedia(printUrl, 'photo')" class="download-img-btn" aria-label="Download Photo">
        <img src="Assets/currentSession/downloadPhoto.png" alt="Download Photo" />
      </button>

      @if (photoOrientations['print'] === 'strip') {
      <div class="print-frame-strip-container clickable" (click)="openModal(printUrl)">
        <img class="print-frame-base" src="Assets/currentSession/jpgframe_strip.png" alt="Photo Frame" />
        <img class="user-print-strip-overlay" [src]="printUrl" alt="Session Photo"
          (load)="onImageLoad($event, 'print')" />
      </div>
      } @else if (photoOrientations['print'] === '4x6') {
      <div class="print-frame-6x4-container clickable" (click)="openModal(printUrl)">
        <img class="print-frame-base" src="Assets/currentSession/jpgframe_6x4.png" alt="Photo Frame" />
        <img class="user-print-6x4-overlay is-4x6" [src]="printUrl" alt="Session Photo"
          (load)="onImageLoad($event, 'print')" />
      </div>
      } @else if (photoOrientations['print'] === '6x4') {
      <div class="print-frame-6x4-container clickable" (click)="openModal(printUrl)">
        <img class="print-frame-base" src="Assets/currentSession/jpgframe_6x4.png" alt="Photo Frame" />
        <img class="user-print-6x4-overlay" [src]="printUrl" alt="Session Photo"
          (load)="onImageLoad($event, 'print')" />
      </div>
      } @else {
      <div class="img-wrapper clickable" (click)="openModal(printUrl)">
        <img class="base-media" [src]="printUrl" alt="Session Photo" (load)="onImageLoad($event, 'print')" />
      </div>
      }

      <!-- Hidden image solely to trigger load event if orientation is not yet calculated -->
      @if (!photoOrientations['print']) {
      <img [src]="printUrl" style="display:none;" (load)="onImageLoad($event, 'print')" />
      }
    </div>
    }
  </div>
  }

  @if (selectedMedia) {
  <div class="modal-overlay" (click)="closeModal()">
    <!-- Top header bar for the modal -->
    <div class="modal-header-bar" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeModal()" aria-label="Close">✕</button>
      <img class="modal-logo" src="Assets/KPhoto-Logo 4.png" alt="KPhoto Logo" />
    </div>

    <div class="modal-content" (click)="$event.stopPropagation()">
      <img class="modal-photo" [src]="selectedMedia" alt="Enlarged media" />
    </div>
  </div>
  }

  @if (!isLoading && !printUrl && !gifUrl && sessionId) {
  <div class="empty-state">
    @if (isOver48Hours || isMediaConfirmedUnavailable) {
    <div class="retention-warning-card" role="alert">
      <div class="retention-icon">⏳</div>
      <div class="retention-content">
        <h3 class="retention-title">Online Media Window Expired</h3>
        <p class="retention-text">
          Online photos are kept for 48 hours after your session. Save them to My Gallery to keep them available longer. This session is past that window, and its photos aren't available here.
        </p>
      </div>
    </div>
    } @else {
    <p>No media found for this session yet.</p>
    <a routerLink="/home/refund" class="empty-state-refund-link">Experiencing an issue with your booth session? Click here for assistance</a>
    }
  </div>
  }
</div>